import { Observable, of } from "rxjs";
import { IHospitalContactPerson, IHospitalStudent } from "../../models/Hospital";
import { HospitalService } from '../../services/hospital.service';
import { tap } from "rxjs/operators";

const cache: {
    person?: IHospitalContactPerson,
    studentsByCompany: { [companyId: string]: IHospitalStudent[] }
} = {
    studentsByCompany: {}
};

export const store = {
    getPerson(): IHospitalContactPerson {
        return cache.person;
    },
    setPerson(person: IHospitalContactPerson) {
        cache.person = person;
    },
    getStudents(companyId: string): IHospitalStudent[] | undefined {
        return cache.studentsByCompany[companyId];
    },
    loadStudents(service: HospitalService, companyId: string, force?: boolean): Observable<IHospitalStudent[]> {
        if (!force && cache.studentsByCompany[companyId]) {
            return of(cache.studentsByCompany[companyId]);
        } else {
            const upn = store.getPerson()?.Upn;
            return service.getStudents(companyId, upn).pipe(tap(data => {
                cache.studentsByCompany[companyId] = data;
            }));
        }
    }
};
